import React, { useContext, useEffect, useRef, useState } from "react";
import { Alert, Grid, Spin, Menu } from "@arco-design/web-react";
import { Host } from "@/utils/common";

import axios from "axios";
import {
  IconApps,
  IconArchive,
  IconBulb,
  IconCodeSquare,
  IconCompass,
  IconCustomerService,
  IconDashboard,
  IconDesktop,
  IconExperiment,
  IconFilePdf,
  IconFire,
  IconGift,
  IconLocation,
  IconLiveBroadcast,
  IconMessage,
  IconPhone,
  IconPlayCircle,
  IconPublic,
  IconQuote,
  IconStamp,
  IconSun,
  IconUserAdd,
  IconUserGroup,
  IconVideoCamera,
  IconVoice,
} from "@arco-design/web-react/icon";
import { useHistory } from "react-router";

const Row = Grid.Row;
const Col = Grid.Col;
const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

import AIRevLogo from "@/assets/airev-logo.svg";

function InterfaceMenu() {
  const shouldRender = !window.location.pathname.startsWith("/login");

  // const params = new URLSearchParams(search);
  const history = useHistory();

  const currentPath = location.pathname;
  const tmpCurrLoc = currentPath.split("/").pop();

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null as any);
  const [data, setData] = React.useState(null as any);

  const defaultOpenKeys = [tmpCurrLoc];
  const [openKeys, setOpenKeys] = useState<string[]>(defaultOpenKeys);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([tmpCurrLoc]);

  const getResults = () => {
    if (!shouldRender) {
      return;
    }

    setLoading(true);

    const url = `/api/v1/menu`;

    axios
      .get(Host + url)
      .then((res) => {
        setData(res.data);

        for (let i = 0; i < res.data.menu.length; i++) {
          if (tmpCurrLoc.startsWith("emp")) {
            setOpenKeys(["emp"]);
          } else if (
            "dep" + res.data.menu[i].id === tmpCurrLoc ||
            "una" + res.data.menu[i].id === tmpCurrLoc
          ) {
            setOpenKeys(["dep" + res.data.menu[i].id]);
          } else {
            for (let j = 0; j < res.data.menu[i].projects.length; j++) {
              if ("prj" + res.data.menu[i].projects[j].id === tmpCurrLoc) {
                setOpenKeys(["dep" + res.data.menu[i].id]);
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err);
        setData(null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getResults();
  }, []);

  const getIcon = (key) => {
    switch (key) {
      case "adm":
        return <IconStamp />;
      case "am":
        return <IconUserGroup />;
      case "cos":
        return <IconSun />;
      case "de":
        return <IconDesktop />;
      case "hr":
        return <IconUserAdd />;
      case "ma":
        return <IconPlayCircle />;
      case "man":
        return <IconCompass />;
      case "packages":
        return <IconPublic />;
      case "philanthropy":
        return <IconGift />;
      case "sa":
        return <IconQuote />;
      case "tech":
        return <IconCodeSquare />;
      case "well":
        return <IconBulb />;
      case "sa-prod":
        return <IconPhone />;
      case "ma-prod":
        return <IconLocation />;
      case "de-prod":
        return <IconFire />;
      case "sa-vb":
        return <IconMessage />;
      case "de-vb":
        return <IconFilePdf />;
      case "ma-vb":
        return <IconVideoCamera />;
      case "de-voice":
        return <IconVoice />;
      case "sa-voice":
        return <IconCustomerService />;
      case "ma-voice":
        return <IconLiveBroadcast />;
      case "prod-rnd":
        return <IconExperiment />;
    }

    return <IconApps />;
  };

  const hasArchived = (item) => {
    for (let i = 0; i < item.projects.length; i++) {
      if (item.projects[i].archived) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      {(shouldRender && (
        <div>
          {loading && <Spin />}
          {error && (
            <Alert
              type="error"
              content={
                <div>
                  <p>
                    Something went wrong. <br />
                    {error.message}
                  </p>
                </div>
              }
            />
          )}
          {data && (
            <Menu
              className={"own-menu"}
              autoScrollIntoView={true}
              onClickMenuItem={(key) => {
                const xkey = "/board/" + key;
                if (history.location.pathname !== xkey) {
                  history.push(xkey);
                }
                setSelectedKeys([key]);
              }}
              // collapse={collapsed}
              // onClickMenuItem={onClickMenuItem}
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onClickSubMenu={(_, openKeys) => setOpenKeys(openKeys)}
            >
              {/*<span style={{fontSize: '12px', margin: '0 0 4px 8px', display: 'block'}}>Departments</span>*/}
              <div style={{ display: "block" }}>
                <div className={"main-logo"}>
                  <AIRevLogo />
                </div>
              </div>
              {data.is_admin && (
                <>
                  <MenuItem key={"budget-overview"}>
                    <IconDashboard /> Budget Overview
                  </MenuItem>
                  <hr
                    style={{
                      border: "1px dashed #e8e8e8",
                      margin: "4px 0",
                    }}
                  />
                </>
              )}
              {data.menu &&
                data.menu.map((item) => {
                  // if (item.projects.length > 0 || item.hasNotAssigned) {
                  return (
                    <SubMenu
                      selectable={false}
                      key={"dep" + item.id}
                      title={
                        <>
                          {getIcon(item.id)} {item.name}
                        </>
                      }
                    >
                      {item.canSeeAll && (
                        <MenuItem key={"dep" + item.id}>
                          Entire Department
                        </MenuItem>
                      )}
                      {item.canSeeUnassigned && (
                        <>
                          {/*{item.hasNotAssigned && (*/}
                          <MenuItem
                            key={"una" + item.id}
                            disabled={!item.hasNotAssigned}
                          >
                            Unassigned hours
                          </MenuItem>
                          {/*)}*/}
                        </>
                      )}
                      {item.projects.length > 0 && (
                        <>
                          <hr
                            style={{
                              border: "1px dashed #e8e8e8",
                              margin: "4px 0",
                            }}
                          />
                          {/*<span style={{fontSize: '12px', margin: '0 0 4px 18px', display: 'block'}}>Projects</span>*/}
                        </>
                      )}
                      {item.projects.length > 0 &&
                        item.projects.map((subItem) => {
                          if (subItem.archived) {
                            return null;
                          }

                          return (
                            <MenuItem key={"prj" + subItem.id}>
                              {subItem.name}
                            </MenuItem>
                          );
                        })}
                      {item.projects.length > 0 && hasArchived(item) && (
                        <>
                          <hr
                            style={{
                              border: "1px dashed #e8e8e8",
                              margin: "4px 0",
                            }}
                          />
                          <SubMenu
                            selectable={false}
                            key={"arch" + item.id}
                            title={
                              <>
                                <IconArchive /> Archived Projects
                              </>
                            }
                          >
                            {item.projects.map((subItem) => {
                              if (!subItem.archived) {
                                return null;
                              }

                              return (
                                <MenuItem key={"prj" + subItem.id}>
                                  {subItem.name}
                                </MenuItem>
                              );
                            })}
                          </SubMenu>
                        </>
                      )}
                    </SubMenu>
                  );
                  // } else {
                  //   return (
                  //     <MenuItem key={"dep"+item.id}>
                  //       {getIcon(item.id)} {item.name}
                  //     </MenuItem>
                  //   );
                  // }
                })}

              {data.employees && (
                <SubMenu
                  selectable={false}
                  key={"emp"}
                  title={
                    <>
                      <IconUserGroup /> Employees
                    </>
                  }
                >
                  {data.employees.map((item) => {
                    return (
                      <MenuItem key={"emp" + item.id}>
                        {item.first_name} {item.last_name}
                      </MenuItem>
                    );
                  })}
                </SubMenu>
              )}
            </Menu>
          )}
        </div>
      )) || (
        <div style={{ display: "block" }}>
          <div className={"main-logo"}>
            <AIRevLogo />
          </div>
        </div>
      )}
    </>
  );
}

export default InterfaceMenu;
